import React from "react";
import "./style.scss";

export const PersonalDataConsent = ({ lang }) => {
  const isRu = lang === "ru";
  return (
    <section>
      <div className="container">
        <h4 className="privacy-header">
          <strong>
            <b>Согласие на обработку персональных данных</b>
          </strong>
        </h4>

        <p>
          Настоящим, Пользователь, в соответствии с Федеральным законом от
          27.07.2006 № 152-ФЗ «О персональных данных», оставляя заявку на
          веб-сайте{" "}
          <a
            href="https://mobile.itfox-web.com"
            style={{ color: "#FFa910" }}
            target="_blank"
            rel="noreferrer"
          >
            mobile.itfox-web.com
          </a>
          , нажимая на кнопки «Отправить», «Заказать консультацию»,
          «Откликнуться», свободно, по своей воле и в своем интересе, а также
          подтверждая свою дееспособность, выражает свое полное согласие на
          обработку персональных данных (далее — Согласие) Обществу с
          ограниченной ответственностью "АЙТИФОКС" (далее – Оператор),ИНН
          2367016947 ОГРН 1202300067056, которому принадлежит веб-сайт{" "}
          <a
            href="https://mobile.itfox-web.com"
            style={{ color: "#FFa910" }}
            target="_blank"
            rel="noreferrer"
          >
            mobile.itfox-web.com
          </a>{" "}
          и которое зарегистрировано по адресу: 354354, Краснодарский край, г.о.
          город-курорт Сочи, г Сочи, р-н Адлерский, ул Лесная, д. 7, кв. 1/А,
          электронная почта{" "}
          <a
            href="mailto:hello@itfox-web.com"
            style={{ color: "#FFa910" }}
            target="_blank"
            rel="noreferrer"
          >
            hello@itfox-web.com
          </a>
          :
        </p>
        <div className="privacy-list-item">
          <span className="privacy-number">1.</span>
          <p>
            Данное Согласие дается на обработку персональных данных, с
            использованием средств автоматизации, без использования средств
            автоматизации, а также смешанным способом.
          </p>
        </div>

        <div className="privacy-list-item">
          <span className="privacy-number">2.</span>
          <p>
            Согласие дается на обработку следующих персональных данных
            Пользователя: персональные данные, относящиеся к категории общие:
            фамилия, имя, отчество, e-mail, номер телефона, желаемая вакансия,
            ссылка на профиль в социальной сети или сервисе обмена мгновенными
            сообщениями (в случае, если кандидат предоставил такие сведения),
            резюме, город проживания, результаты тестирования, IP-адрес
            устройства Пользователя, местоположение, файлы cookies, иные
            сведения, предоставленные Пользователем в рамках взаимодействия с
            Оператором.
          </p>
        </div>

        <div className="privacy-list-item">
          <span className="privacy-number">3.</span>
          <p>
            Цель обработки персональных данных: обсуждение проекта, обработка
            входящих заявок и предоставление консультаций, проведение
            предварительного собеседования для трудоустройства или иного вида
            занятости, включая оказание услуг/выполнение работ Пользователем на
            основании договора гражданско-правового характера, содействие
            занятости и предоставление возможности трудоустройства.
          </p>
        </div>

        <div className="privacy-list-item">
          <span className="privacy-number">4.</span>
          <p>
            В ходе обработки с персональными данными совершаются любые действия
            (операции) или совокупность действий (операций), включая: сбор,
            получение, запись, систематизацию, накопление, хранение, уточнение,
            обновление, изменение, извлечение, использование, обезличивание,
            блокирование, удаление, уничтожение персональных данных.
          </p>
        </div>

        <div className="privacy-list-item">
          <span className="privacy-number">5.</span>
          <p>
            Датой выдачи настоящего согласия на обработку персональных данных
            является дата создания запроса на Сайте. Согласие действует с
            момента его предоставления в течение всего периода использования
            Пользователем, до момента отзыва согласия или до достижения
            вышеуказанных целей обработки персональных данных, если иное не
            предусмотрено законодательством РФ.
          </p>
        </div>

        <div className="privacy-list-item">
          <span className="privacy-number">6.</span>
          <p>
            При предоставлении Согласия на обработку Персональных данных для
            целей трудоустройства Согласие вступает в силу со дня его подписания
            и действует в течение 30 суток с момента принятия решения о
            несоответствии кандидатуры Пользователя требованиям по вакантным
            должностям.
          </p>
        </div>

        <div className="privacy-list-item">
          <span className="privacy-number">7.</span>
          <p>
            Согласие может быть отозвано Пользователем или представителем
            Пользователя путем направления Обществу с ограниченной
            ответственностью "АЙТИФОКС" письменного заявления или электронного
            заявления по адресу, указанному в начале Согласия.
          </p>
        </div>

        <div className="privacy-list-item">
          <span className="privacy-number">8.</span>
          <p>
            В случае отзыва Согласия Оператор вправе продолжить обработку
            персональных данных без него при наличии оснований, указанных в
            пунктах 2 — 11 части 1 статьи 6, части 2 статьи 10 и части 2 статьи
            11 Федерального закона № 152-ФЗ «О персональных данных» от
            27.07.2006 г.
          </p>
        </div>

        <div className="privacy-list-item">
          <span className="privacy-number">9.</span>
          <p>
            Согласие действует все время до момента прекращения обработки
            персональных данных, указанных в п. 7 и п. 8 Согласия.
          </p>
        </div>

        <div className="privacy-list-item">
          <span className="privacy-number">10.</span>
          <p>
            Пользователь подтверждает, что ознакомлен с{" "}
            <a
              style={{ color: "#FFa910" }}
              target="_blank"
              rel="noreferrer"
              href="/privacy-policy/ru"
            >
              Политикой конфиденциальности
            </a>
            .
          </p>
        </div>
      </div>
    </section>
  );
};
